import React, { Component } from 'react';
import { connect } from "react-redux";

import classNames from 'classnames';
import PropTypes from 'prop-types';
import StrokeConfirm from '../icons/StrokeConfirm';
import StrokeCancel from '../icons/StrokeCancel';
import GlyphSmallCancel from '../icons/GlyphSmallCancel';
import '../css/SelectedActions.css'

import { Definition, DefinitionList } from '../components/Definition';

const styles = {
  bar: {
    background: '#F0F6FA',
    borderColor: '#CFE0E2',
    color: '#59595A'
  },
  size: {
    color: '#A4BFCC'
  }
}

const classes = {
  svg: (v) => v ? 'w3 pointer hover-fill-navy-muted' : 'w3',
  action: (v) => v ? 'pointer' : 'disabled o-20'
}

const textClasses = {
  action: (v) => v ? 'ma0 f6 pointer' : 'ma0 f6 disabled'
}


class ConfirmAction extends Component {
  constructor(props) {
    super(props)
    this.containerRef = React.createRef()
  }

  static propTypes = {
    animateOnStart: PropTypes.bool
  }

  static defaultProps = {
    className: ''
  }

  state = {
    force100: false
  }

  componentDidMount () {
    this.containerRef.current && this.containerRef.current.focus()
  }

  render () {
    const { animateOnStart, confirm, cancel, close, jabraNumber, startString, endString, reserving, canceling, processing, className, style, ...props } = this.props;

    return (
      <div className={classNames('times-new-roman bt w-100 pa3 ph4-l', className, animateOnStart && 'selectedActionsAnimated')} style={{ ...styles.bar, ...style, maxWidth: '100%' }} {...props}>
        <div className='flex items-center justify-between' role="menu" aria-label={'menuOptions'} ref={ this.containerRef } tabIndex="0" style={{ outline: 'none' }}>
          <DefinitionList>
            { reserving ? <div className='mb1'><span>You are about to <span className='green'>reserve</span></span></div> : null }
            { canceling ? <div className='mb1'><span>You are about to <span className='green'>cancel</span></span></div> : null }
            <Definition term='Jabra Number' desc={jabraNumber} />
            <Definition term='Start Time' desc={startString} />
            <Definition term='End Time' desc={endString} />
          </DefinitionList>
          <div className='flex'>
            <button role="menuitem" className='tc ph3' onClick={confirm} disabled={!reserving}>
              <StrokeConfirm className={classNames(classes.action(reserving))} fill='#A4BFCC' aria-hidden="true"/>
              <p className={classNames(textClasses.action(reserving))}>Confirm</p>
            </button>
            <button role="menuitem" className='tc ph3' onClick={cancel} disabled={!canceling}>
              <StrokeCancel className={classNames(classes.action(canceling))} fill='#A4BFCC' aria-hidden="true"/>
              <p className={classNames(textClasses.action(canceling))}>Cancel</p>
            </button>
          </div>
          <div className='flex fr justify-end w5-l'>
            <button onClick={close} className='flex items-center justify-end f6 charcoal'>
              <span className='mr2 db-m'>Close</span>
              <GlyphSmallCancel onClick={close} className='fill-charcoal w1 o-70' viewBox='37 40 27 27' />
            </button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  processing: state.reserve.processing
});

export default connect(mapStateToProps)(ConfirmAction);
